import { MouseEvent } from "react";

export const formatCategory = (
  category: string,
  onClick?: (
    e: MouseEvent<HTMLSpanElement, globalThis.MouseEvent>,
    category: string,
  ) => void,
): React.ReactNode => {
  return (
    <div className="category-container">
      {category &&
        category
          .split("|")
          .sort()
          .map((cat, index) => (
            <div
              className="category"
              key={`ContactsColumns_${category}_${index}`}
            >
              <span className={"category-label"}>
                {cat}{" "}
                {onClick && (
                  <span
                    onClick={(e) => onClick(e, cat)}
                    className={"category-link"}
                  />
                )}
              </span>
            </div>
          ))}
    </div>
  );
};

export const formatOfficeName = (officeName: string): string => {
  return officeName && officeName.startsWith("Cabinet")
    ? officeName
    : "Cabinet " + officeName;
};

export const formatName = (name?: string): string => {
  if (!name) {
    return "";
  }
  const lowerCase = name.toLowerCase();
  const firstLetter = lowerCase.charAt(0);
  const rest = lowerCase.substring(1);
  return firstLetter.toUpperCase() + rest;
};

export const formatPrice = (price: number): string => {
  const parts = price.toFixed(2).split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return parts.join(",");
};

export const formatPriceWithEuro = (price: number): string => {
  return formatPrice(price) + " €";
};
